import { useState } from 'react';
import { observer } from 'mobx-react';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Grid } from '@material-ui/core';
import { Button } from '@roc/ui';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    accordion: {
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: 16,
      boxShadow: 'none',
      overflow: 'hidden',
      '&::before': {
        display: 'none',
      },
      '&.Mui-expanded': {
        margin: 0,
      },
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      fontWeight: theme.typography.fontWeightMedium,
      marginLeft: theme.spacing(2),
    },
    summary: {
      backgroundColor: '#F6F7FB',
      flexDirection: 'row-reverse',
      paddingLeft: theme.spacing(1),
    },
    details: {
      padding: 0,
      // the grid inside already sits in this rounded card; drop its own card border
      '& .ag-theme-alpine': {
        border: 'none',
        borderRadius: 0,
      },
    },
    button: {
      height: '30px',
      padding: '4px 8px',
      border: '1px solid #285391',
      color: '#285391',
      textTransform: 'none',
      backgroundColor: 'white',
    },
  }),
);

export const DrawsAccordion = observer(({ title, children, onViewClick = null }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(true);

  return (
    <div className={classes.root}>
      <Accordion
        className={classes.accordion}
        expanded={expanded}
        onChange={(e, expanded) => setExpanded(expanded)}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          className={classes.summary}
          id="panel1a-header"
        >
          <Grid container direction='row' spacing={2} justifyContent='space-between'>
            <Grid item>
              <Typography className={classes.heading}>{title}</Typography>
            </Grid>
            {onViewClick &&
              <Grid item>
                <Button
                  testId={`view-property-details${title}`}
                  variant='outlined'
                  className={classes.button}
                  onClick={(event) => onViewClick(event)}
                >
                  View Property Details
                </Button>
              </Grid>
            }
          </Grid>
        </AccordionSummary>
        <AccordionDetails className={classes.details}>
          {children}
        </AccordionDetails>
      </Accordion>
    </div>
  );
});
